/* eslint-disable no-restricted-syntax, guard-for-in */
import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'

export default function LoadCounts(data, chartOptions = {}) {
    const counts = []
    const types = chartOptions.types || {
        ballPropertyName: 'balls',
        strikePropertyName: 'strikes',
    }

    for (let balls = 0; balls < 4; balls++) {
        for (let strikes = 0; strikes < 3; strikes++) {
            // Get different pitch types per count
            const pitchBreakdown = filter(
                data,
                (d) =>
                    Number(d[types.strikePropertyName]) === strikes &&
                    Number(d[types.ballPropertyName]) === balls
            )

            const percentages = groupBy(pitchBreakdown, (d) => d.pitchType)
            let count = 0
            for (const percent in percentages) {
                count += percentages[percent].length
            }

            const countBreakdown = {
                name: `${balls}${strikes}`,
                strikes,
                balls,
                layer: strikes + balls,
            }

            const children = []
            let totalPitches = 0
            for (const percent in percentages) {
                const pitch = {}
                pitch.name = percent
                pitch.value = String(
                    Number(percentages[percent].length / count).toFixed(3)
                )
                pitch.total = Number(percentages[percent].length)
                pitch.isPitch = true
                pitch.layer = countBreakdown.layer
                pitch.pitchName = percentages[percent][0].pitchName

                totalPitches += percentages[percent].length
                children.push(pitch)
            }
            countBreakdown.children = children
            countBreakdown.totalPitches = totalPitches
            counts.push(countBreakdown)
        }
    }
    return counts
}
